import { eEntityTypeDTO, eLogoutReason } from '../Enums/Enums';
import * as userManagementActions from '../Components/UserManagement/controllers/actions';
import $ from 'jquery';
import format from 'date-fns/format';
import { enGB } from 'date-fns/locale';
import * as constActions from 'common/Components/MasterSlave/controllers/const';
import { DEFAULT_UI_DATETIME_FORMAT } from 'utils/dateAndTime';

export default class Commons {
  static updateUserInteraction(dispatch) {
    $.ajax({
      type: 'GET',
      url: '/WebApp/Account/UserInteractionSessionPersistence',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      credentials: process.env.REACT_APP_CREDENTIALS_MODE,
      cache: false,
      success: function (data) {
        if (data == 'logout') {
          dispatch({ type: constActions.RESET_STORE });
          userManagementActions.logOut(eLogoutReason.UpdateUserInteractionSuccessLogout);
        }
      },
      error: function (data) {
        if ([401, 403].includes(data.status)) {
          dispatch({ type: constActions.RESET_STORE });
          userManagementActions.logOut(eLogoutReason.UpdateUserInteractionResponseStatus401);
        }
      }
    });
  }

  static LimitTop(name, maxLegnth) {
    let retVal = name && name.length > maxLegnth ? '...' + name.substring(name.length - maxLegnth) : name;
    return retVal;
  }

  static LimitStart(name, maxLegnth) {
    let retVal = name && name.length > maxLegnth ? name.substring(0, maxLegnth) + '...' : name;
    return retVal;
  }

  static CreateRegularYadKefSearchPattern(parameters, start = null, end = null, orderByDetails = '') {
    let _pathYadKef = '';
    Object.keys(parameters).forEach(function (item) {
      switch (parameters[item].type) {
        case 'minMax': {
          _pathYadKef += `&columns[${parameters[item].id}][search][value]=${encodeURIComponent(
            parameters[item].minValue
          )}-yadcf_delim-${encodeURIComponent(parameters[item].maxValue)}`;
          break;
        }
        case 'regular': {
          _pathYadKef += `&columns[${parameters[item].id}][search][value]=${encodeURIComponent(
            parameters[item].value
          )}`;
          break;
        }
        case 'multi': {
          let paramValue = '';
          if (parameters[item].value.length > 0) {
            parameters[item].value.forEach(element => {
              paramValue += `${element}_`;
            });
            paramValue = paramValue.slice(0, -1);
          }
          _pathYadKef += `&columns[${parameters[item].id}][search][value]=${encodeURIComponent(paramValue)}`;
          break;
        }
      }
    });

    const startPage = start !== null ? `&start=${start}` : '';
    const pageLimit = end !== null ? `&length=${end}` : '';
    const paging = `${startPage}${pageLimit}`;
    return `${paging}${_pathYadKef}${Commons.getOrderBy(orderByDetails)}`;
  }

  static getOrderBy(orderByDetails) {
    if (!orderByDetails) {
      return '';
    }
    if (Array.isArray(orderByDetails)) {
      return '&' + Commons.getOrderByMultiple(orderByDetails);
    }
    return '&' + Commons.getOrderBySingle(orderByDetails);
  }

  static getOrderBySingle(element, idx = 0) {
    return `order[${idx}][column]=${element.columnId}&order[${idx}][dir]=${element.type}`;
  }

  static getOrderByMultiple(elements) {
    return elements.map((x, idx) => Commons.getOrderBySingle(x, idx)).join('&');
  }

  static CreateAdvancedYadKefSearchData(entityType, arr, columns, start, end, searchId) {
    let postDatax = {
      start_page: start,
      page_length: end,
      entity: entityType,
      criterias: arr,
      included_fields: columns,
      search_id: searchId
    };
    return postDatax;
  }

  static findKeyByValue(set, value) {
    for (let k in set) {
      // eslint-disable-next-line no-prototype-builtins
      if (set.hasOwnProperty(k)) {
        if (set[k] == value) {
          return k;
        }
      }
    }
    return undefined;
  }

  static convertEntityTypeToString(value) {
    switch (value) {
      case eEntityTypeDTO.File:
        return 'File';
      case eEntityTypeDTO.Host:
        return 'Host';
      case eEntityTypeDTO.User:
        return 'User';
      case eEntityTypeDTO.Domain:
        return 'TrafficAnalyzer';
      case eEntityTypeDTO.Socket:
        return 'Sockets';
    }
  }

  static convertEntityEnumToString(value) {
    switch (value) {
      case eEntityTypeDTO.File:
        return 'File';
      case eEntityTypeDTO.Host:
        return 'Host';
      case eEntityTypeDTO.User:
        return 'User';
      case eEntityTypeDTO.Domain:
        return 'Network';
      case eEntityTypeDTO.All:
        return 'All';
    }
  }

  static isNumber(value) {
    return Number(value) === value;
  }

  static guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  static getDateNow() {
    return format(new Date(), 'MMMM dd, HH:mm');
  }

  static getDateFormatToDisplay(date) {
    if (date instanceof Date && !isNaN(date)) {
      return format(date, DEFAULT_UI_DATETIME_FORMAT);
    } else {
      return '';
    }
  }

  static padToTwo(number) {
    if (number <= 9999) {
      number = ('0' + number).slice(-2);
    }
    return number;
  }

  static getPropByName(object, key) {
    return object[
      Object.keys(object).filter(ownKey => {
        return ownKey === key;
      })[0]
    ];
  }

  static getEnumPropByKey(obj, key) {
    for (var k in obj) {
      if (obj[k] == key) return k;
    }
    return null;
  }

  static isInternetExplorer() {
    let retVal = false;

    let ua = window.navigator.userAgent;

    if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('rv:') > 0 || ua.indexOf('Edge/') > 0) {
      retVal = true;
    }
    return retVal;
  }

  static FormateDateTime(dt) {
    return format(dt, 'MM/dd/yyyy');
  }

  static downloadFileFromString(filename, text) {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  static getEnumValuesArray(inpEnum) {
    let retVal = [];
    Object.keys(inpEnum).forEach(function (key, index) {
      if (key !== 'UNKNOWN') {
        retVal.push({ label: inpEnum[key].name, value: inpEnum[key].value });
      }
    });
    return retVal;
  }

  static downloadUsingIframe(src) {
    //remove old iframe if exists -> using the onload event dowsnt work
    let iframeOld = document.getElementById('download_iframe_id');
    if (iframeOld) {
      iframeOld.parentElement.removeChild(iframeOld);
      // iframeOld.remove();//IE does not support remove method
    }

    //apend a new hidden iframe
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.id = 'download_iframe_id';
    iframe.src = src;
    document.body.appendChild(iframe);
  }

  static CreateArrayEnum(enumObject, isSelected = true) {
    var all = [];
    for (var key in enumObject) {
      let newValue = _deepCopy(enumObject[key]);
      newValue.isSelected = isSelected;
      all.push(newValue);
    }
    return all;
  }
}

export function isObjectEmpty(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

export function copyToClipboard(text) {
  var dummy = document.createElement('input');
  document.body.appendChild(dummy);
  dummy.setAttribute('value', text);
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
}

export function _deepCopy(item) {
  let retVal = item;
  if (!isObjectEmpty(item)) {
    let json = JSON.stringify(item);
    retVal = JSON.parse(json);
  }
  return retVal;
}

export function addItemIfNotContains(arr, item) {
  if (!arr.includes(item)) return [...arr, item];
  else return arr;
}

export function makeCancelable(promise) {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => (hasCanceled_ ? reject({ isCanceled: true }) : resolve(val)),
      error => (hasCanceled_ ? reject({ isCanceled: true }) : reject(error))
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}

export const _getPrettyTime = () =>
  new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  }).format(Date.now());

export const getPrettyTime = () => format(new Date(), 'MMMM dd, HH:mm', { locale: enGB });

export const hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
